(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index1_1"] && !Shopify.designMode) return;
  try {
    
/* Load the homepage Instagram embeds only when their section is nearby. */
(function () {
  function processEmbeds() {
    if (window.instgrm && window.instgrm.Embeds) {
      window.instgrm.Embeds.process();
    }
  }

  function loadInstagram() {
    if (window.instgrm && window.instgrm.Embeds) {
      processEmbeds();
      return;
    }

    var script = document.querySelector(
      'script[src="https://www.instagram.com/embed.js"], script[src="//www.instagram.com/embed.js"]'
    );
    if (script) {
      script.addEventListener('load', processEmbeds, { once: true });
      return;
    }

    script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    script.addEventListener('load', processEmbeds, { once: true });
    document.head.appendChild(script);
  }

  function watchEmbeds(root) {
    root.querySelectorAll('[data-tedemogu-instagram]').forEach(function (group) {
      if (group.hasAttribute('data-tedemogu-instagram-observed')) return;
      group.setAttribute('data-tedemogu-instagram-observed', '');

      if (!('IntersectionObserver' in window)) {
        loadInstagram();
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          loadInstagram();
        }
      }, { rootMargin: '800px 0px', threshold: 0 });
      observer.observe(group);

      var section = group.closest('.shopify-section');
      if (section) {
        section.addEventListener('shopify:section:unload', function () {
          observer.disconnect();
        }, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watchEmbeds(document);
    }, { once: true });
  } else {
    watchEmbeds(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    watchEmbeds(event.target);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
	super();

	this.addEventListener('change', debounce((event) => {
		const body = JSON.stringify({ note: event.target.value });
		fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
	}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
class ProductRecommendations extends HTMLElement {
	constructor() {
	super();

	const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;
		observer.unobserve(this);

		fetch(this.dataset.url)
		.then(response => response.text())
		.then(text => {
			const html = document.createElement('div');
			html.innerHTML = text;
			const recommendations = html.querySelector('product-recommendations');

			if (recommendations && recommendations.innerHTML.trim().length) {
			this.innerHTML = recommendations.innerHTML;
			}

			if (html.querySelector('.grid__item')) {
			this.classList.add('product-recommendations--loaded');
			}
		})
		.catch(e => {
			console.error(e);
		});
	}

	new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
